<template>
    <div class="main-container container">
        <form>
            <h2>اطلاعات کاربر</h2>
            <img @click="back" class="back" :src="Back" alt="Back">

            <!-- FULL NAME -->
            <div class="form-group" :class="{'invalid': error.fullname}">
                <label for="emailFeild">نام و نام‌خانوادگی</label>
                <div class="row">
                    <div class="col-6" style="padding-left: 2px;">
                        <input 
                            v-model="firstname" type="firstname" 
                            id="firstnameFeild" class="form-control"
                            placeholder="نام"
                        >
                    </div>
                    <div class="col-6" style="padding-right: 2px;">
                        <input 
                            v-model="lastname" type="lastname" 
                            id="lastnameFeild" class="form-control"
                            placeholder="نام خانوادگی"
                        >
                    </div>
                </div>
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <!-- PHONE NUMBER -->
            <div class="form-group" :class="{'invalid': error.number}">
                <label for="numberFeild">شماره موبایل</label>
                <input 
                    disabled
                    v-model="number" type="number" 
                    id="numberFeild" class="form-control"
                    placeholder="شماره موبایل خود را وارد نمایید"
                >
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <button type="button" @click="change" class="btn btn-dark">تغییر اطلاعات</button>

            <!-- <hr> -->

            <!-- PASS -->
            <!-- 
            <div class="form-group" :class="{'invalid': error.pass}">
                <label for="passFeild">رمز عبور جدید</label>
                <input 
                    v-model="pass" type="password" 
                    id="passFeild" class="form-control"
                    placeholder="رمز عبور جدید را وارد نمایید"
                >
                <small id="passwordHelp" class="form-text text-muted">رمز عبور شما می‌بایست حداقل ۸کاراکتر را شامل گردد.</small>
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div> 

            <div class="form-group" :class="{'invalid': error.cpass}">
                <label for="cpassFeild">تکرار رمز عبور</label>
                <input 
                    v-model="cpass" type="password" 
                    id="cpassFeild" class="form-control"
                    placeholder="رمز عبور جدید را مجددا وارد نمایید"
                >
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div> 
            -->

            <!-- <button type="button" @click="changePass" class="btn btn-dark">تغییر رمز عبور</button> -->
        </form>
    </div>
</template>

<script>
import Back from '@/assets/images/courses/content/left-back.png';

import { getRequest, postRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';
const uniqid = require('uniqid');

export default {
    name: 'ChangeInfo',
    data() {
        return {
            Back: Back,
            prevRoute: {},
            
            firstname: undefined,
            lastname: undefined,
            number: undefined,
            pass: undefined,
            cpass: undefined,

            error: {
                fullname: false,
                number: false,
                pass: false,
                cpass: false,  
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    mounted() {
        this.getCurrent();
    },
    methods: {
        getCurrent() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let data = rsp['data'];

                    this.firstname = data.FirstName;
                    this.lastname = data.LastName;
                    this.number = data.Number;
                })
                .catch((err) => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        changePass() {           
            this.error = {
                pass: false,
                cpass: false,
            }

            if (!this.pass) {
                this.error.pass = true; 
            }
            if (!this.cpass) {
                this.error.cpass = true; 
            }

            if (
                this.error.pass == false &&
                this.error.cpass == false
            ) {
                if (
                    this.pass == this.cpass
                ) {
                    postRequest('/users/pchange', { 
                        password: this.pass
                    })
                        .then(() => {
                        // response
                            this.$emit('alertMsg', 
                                { message: 'رمز شما با موفقیت تغییر نمود', key: uniqid(), type: 'success' }
                            )
                        })
                        .catch((err) => {
                        // error
                            if(err.response) {
                                this.$emit('alertMsg', 
                                    { message: err.response.data.message, key: uniqid(), type: 'error' }
                                )

                                if (err.response.status == 401) {
                                    Cookies.remove('access_cookie');
                                    this.$router.push({ name: 'Login' })
                                }
                            }
                        });
                } else {
                    this.$emit('alertMsg', 
                        { message: 'رمز شما به درستی تکرار نگردیده است', key: uniqid(), type: 'error' }
                    )
                }
            }
        },
        change() {            
            this.error = {
                fullname: false,
                number: false,
            }

            if (!this.firstname || !this.lastname) {
                this.error.fullname = true; 
            }
            if (!this.number) {
                this.error.number = true; 
            }

            if (
                (Cookies.get('access_cookie')) &&
                !this.error.fullname && 
                !this.error.number
            ) {
                postRequest('/users/update', { 
                    firstname: this.firstname,
                    lastname: this.lastname,
                    number: this.number
                })
                    .then(() => {
                        // response
                        this.getCurrent();

                        this.$emit('alertMsg', 
                            { message: 'اطلاعات با موفقیت تغییر یافتند', key: uniqid(), type: 'success' }
                        )
                    })
                    .catch((err) => {
                        // error
                        if(err.response) {
                            this.$emit('alertMsg', 
                                { message: err.response.data.message, key: uniqid(), type: 'error' }
                            )
                        
                            // check auth
                            if (err.response.status == 401) {
                                Cookies.remove('access_cookie');
                                this.$router.push({ name: 'Login' })
                            }
                        }
                    });
            }
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style src="@/assets/styles/InvalidField.css" scoped></style>
<style scoped>
/* --------------------------------- */
/* ------------ GENERAL ------------ */
/* --------------------------------- */
.main-container {
    width: 100%;
    padding: 25px 10px;
    text-align: right;
}
.main-container h5 {
    cursor: pointer;
    display: inline-block;
}
.main-container form {
    margin-bottom: 1.5rem;
    padding: 10pt;

    /* border: 1px solid #ccc; */
    position: relative;
}
.main-container .back {
    height: 5vh;

    position: absolute;
    top: 10pt;
    left: 10pt;

    cursor: pointer;
}
</style>